import { render, staticRenderFns } from "./PelatihanQuestion.vue?vue&type=template&id=b8883374"
import script from "./PelatihanQuestion.vue?vue&type=script&lang=js"
export * from "./PelatihanQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports